<div class="no-results-container">
  <div class="image-container">
    <img class="box-image" src="assets/images/no-scootaverses.svg" alt="No Scootaverses Image" />
  </div>
  <create-scootaverse></create-scootaverse>
</div>
